module.exports = __webpack_public_path__ + "img/world-map.1dcd1d5b.png";